import React from "react";
import { farmResultsViewModel } from "common/viewModels";
import NameValueSplit from "./NameValueSplit";

const FarmResults = ({ budget }) => {
    const nameValues = farmResultsViewModel(budget).filter((r) => r.key !== "MedianCalvingPeriod");
    return <NameValueSplit nameValues={nameValues} splitBy={2} />;
};

export default FarmResults;
